import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner, Button } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const HOME_URL = 'https://fr.licorne-academy.com';

const PaymentSuccessfulScreen = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const redirectTimeout = setTimeout(() => {
      window.location.href = HOME_URL;
    }, 8000);

    return () => clearTimeout(redirectTimeout);
  }, []);

  return (
    <div className='payment-status-page'>
      <div className='status-panel success'>
        <img src='/licorne.png' alt='Licorne' className='status-brand-logo' />
        <div className='status-icon success-icon'>
          <FaCheckCircle />
        </div>
        <h1>{t('paysucc')}</h1>
        <p>
          {t('payment_success_message') ||
            'Votre paiement a été traité avec succès. Vous recevrez un email de confirmation.'}
        </p>
        <Spinner animation='border' className='status-spinner' />
        <p className='status-redirect'>
          {t('redirecting') || 'Redirection en cours...'}
        </p>
        <div className='status-actions'>
          <Button className='btn-teal' onClick={() => (window.location.href = HOME_URL)}>
            {t('redirect_now') || 'Rediriger maintenant'}
          </Button>
          <Link to='/' className='btn btn-outline-teal'>
            {t('return')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessfulScreen;
